import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const formatPrice = (price) => {
  return price.toFixed(2).replace('.', ',') + ' €';
};

export const calculateSavings = (priceBefore, hours, frequency = 'hebdomadaire') => {
  const freqMultiplier = {
    'ponctuel': 1,
    'hebdomadaire': 4,
    'bi-mensuel': 2,
    'mensuel': 1
  };
  const multiplier = freqMultiplier[frequency] || 1;
  const totalBefore = priceBefore * hours * multiplier;
  const credit = totalBefore * 0.5;
  const totalAfter = totalBefore - credit;
  const pricePerHourAfter = priceBefore / 2;
  
  return {
    totalBefore,
    credit,
    totalAfter,
    pricePerHourAfter,
    hoursPerMonth: hours * multiplier
  };
};

export const COMPANY_INFO = {
  name: 'Ptitservices.com',
  tagline: 'Facilitateur de vies',
  phone: '03 74 47 47 82',
  phoneRaw: '0374474782',
  email: 'contact@artois.ptitservices.com',
  address: '61 rue de la mairie',
  city: '62530 Servins',
  fullAddress: '61 rue de la mairie, 62530 Servins',
  region: 'Artois'
};
